import { Plus, Briefcase, Video, FlaskConical, FileSignature, Handshake } from 'lucide-react';
import { Button } from '@vnetwork/ui/primitives';

/**
 * The action rail at the bottom of each board column. Every column offers Add
 * note + Add negotiation; Presentation adds Create business trip + Meeting
 * online; POC adds Create POC; Contract adds Create contract (until one has
 * completed). Disabled when the journey is locked. Mirrors legacy StepActions.
 */
export function StageActions({
  step,
  disabled,
  hasCompletedContract,
  onAddNote,
  onAddNegotiation,
  onCreateBusinessTrip,
  onCreateMeeting,
  onCreatePOC,
  onCreateContract,
}: {
  step: string;
  disabled: boolean;
  hasCompletedContract: boolean;
  onAddNote: () => void;
  onAddNegotiation: () => void;
  onCreateBusinessTrip: () => void;
  onCreateMeeting: () => void;
  onCreatePOC: () => void;
  onCreateContract: () => void;
}) {
  const full = { width: '100%', justifyContent: 'center' as const };
  return (
    <div
      style={{
        display: 'grid',
        gap: 'var(--vn-space-1)',
        paddingTop: 'var(--vn-space-2)',
        borderTop: '1px solid var(--vn-border-subtle)',
      }}
    >
      <Button size="sm" variant="ghost" disabled={disabled} onClick={onAddNote} style={full}>
        <Plus size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Add note
      </Button>

      {step === 'presentation' ? (
        <>
          <Button size="sm" variant="secondary" disabled={disabled} onClick={onCreateBusinessTrip} style={full}>
            <Briefcase size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Create business trip
          </Button>
          <Button size="sm" variant="secondary" disabled={disabled} onClick={onCreateMeeting} style={full}>
            <Video size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Meeting online
          </Button>
        </>
      ) : null}

      {step === 'poc' ? (
        <Button size="sm" variant="secondary" disabled={disabled} onClick={onCreatePOC} style={full}>
          <FlaskConical size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Create POC
        </Button>
      ) : null}

      <Button size="sm" variant="secondary" disabled={disabled} onClick={onAddNegotiation} style={full}>
        <Handshake size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Add negotiation
      </Button>

      {step === 'contract' && !hasCompletedContract ? (
        <Button size="sm" variant="primary" disabled={disabled} onClick={onCreateContract} style={full}>
          <FileSignature size={13} style={{ marginRight: 'var(--vn-space-1)' }} /> Create contract
        </Button>
      ) : null}
    </div>
  );
}

export default StageActions;
